import { SkeletonText, SkeletonTextHeading, SkeletonTextLine } from '@vp/swan';

export function BriefSkeleton() {
    return (
        <SkeletonText>
            <SkeletonTextHeading fontSize="x3large" />
            <SkeletonTextLine />
            <SkeletonTextLine />
            <SkeletonTextLine />
            <SkeletonTextLine />
            <SkeletonTextLine />
            <SkeletonTextLine />
        </SkeletonText>
    );
}
